// extracted by mini-css-extract-plugin
export default {"download-tickets-button":"DownloadTicketsButton_download-tickets-button__IFTzM","preparing-document":"DownloadTicketsButton_preparing-document__SyQDM"};